// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","wrapper":"articleGrid-module__wrapper___1RP6a"};